module.exports = new __parcel__URL__("uk_3.f58a4276.png").toString();